import { useEffect, useState } from 'react'

import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { IApproval, ICompliance } from '@/types/tasksApprovals'

import SystemIcon from '../../mainContent/systemIcon'

const Container = ({ item }: { item: ICompliance | IApproval }) => {
    const [title, setTitle] = useState(item.title)

    useEffect(() => {
        if (item) {
            setTitle(item.title)
        }
    }, [item])
    return (
        <Box display="flex" alignItems="center">
            <SystemIcon system={item.system_id} />
            <Text style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }} ml="18px">
                {title}
            </Text>
        </Box>
    )
}

export default Container
